module.exports = __webpack_public_path__ + "img/telao-black-1.2c4b0ede.jpg";